// extracted by mini-css-extract-plugin
export default {"popupContainer":"popup_popupContainer","toolip":"popup_toolip"};